import moment from "moment";
import React, { useState } from "react";
import DatePicker from "../../../../components/DatePicker";

const AppointmentDate = ({
  resetData,
  setAppointmentDate,
  getServices,
  salon,
  appointmentDate
}) => {
  const [currentPanelValue, setCurrentPanelValue] = useState(moment());

  const handleChange = (value) => {
    resetData();
    if (value) {
      setAppointmentDate(value.format("YYYY-MM-DD"));
      getServices({}, `/${salon?._id}`);
    }
  };

  const handlePanelChange = (value) => {
    setCurrentPanelValue(value);
  };

  const disableDate = (current) => {
    let customDate = moment();
    if (salon && salon.startBooking === "1 day") {
      customDate.add(1, "days");
    }
    customDate = customDate.format("YYYY-MM-DD");
    const isAfterMaxDate = current && current > moment().endOf("month").add(1, 'month');
    return current && current < moment(customDate, "YYYY-MM-DD") || isAfterMaxDate;
  };

  // Calculate minimum and maximum allowed months
  const getMinMaxMonths = () => {
    let minDate = moment();
    if (salon && salon.startBooking === "1 day") {
      minDate.add(1, "days");
    }
    const maxDate = moment().endOf("month").add(1, 'month');
    
    return {
      minMonth: minDate.startOf("month"),
      maxMonth: maxDate.startOf("month")
    };
  };

  const { minMonth, maxMonth } = getMinMaxMonths();
  
  // Hide left arrow if current panel is at or before minimum month
  const hideLeftArrow = currentPanelValue.isSameOrBefore(minMonth, "month");
  
  // Hide right arrow if current panel is at or after maximum month
  const hideRightArrow = currentPanelValue.isSameOrAfter(maxMonth, "month");

  return (
    <div className="appointment__form__date text--center">
      <DatePicker
        dropdownClassName={` ${hideLeftArrow ? 'hide-left-arrow' : ''} ${hideRightArrow ? 'hide-right-arrow' : ''}`}
        className={`date-picker`}
        placeholder="Select Date"
        onChange={handleChange}
        onPanelChange={handlePanelChange}
        defaultValue={moment(appointmentDate)}
        disabledDate={disableDate}
        prevIcon={hideLeftArrow ? <span></span> : "<"}
        nextIcon={hideRightArrow ? <span></span> : ">"}
      />
    </div>
  );
};

export default AppointmentDate;
